import { useLayoutEffect } from "react"
import { useDispatch } from "react-redux"
import { workqueueActions } from "../../store/workqueue"

/**
 * Registers an active WorkQ edit session while `isActive` is true.
 * Used to defer auto-refresh only during live user interaction.
 */
export function useWorkQEditSession(isActive) {
    const dispatch = useDispatch()

    useLayoutEffect(() => {
        if (!isActive) {
            return undefined
        }

        dispatch(workqueueActions.beginEditSession())
        return () => {
            dispatch(workqueueActions.endEditSession())
        }
    }, [isActive, dispatch])
}
